import ReactECharts from 'echarts-for-react';
import { useEffect, useState } from 'react';


const Chart = (props) => {
    const [option, setOption] = useState({});

    useEffect(() => {
        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            backgroundColor: 'transparent',
            title: {
                text: props.title,
                left: 'center',
                top: 20,
                textStyle: {
                    color: '#5a06a1'
                }
            },
            tooltip: {
                trigger: 'item'
            },
            visualMap: {
                show: false,
                min: 80,
                max: 600,
                inRange: {
                    colorLightness: [0.45, 1]
                }
            },
            series: [
                {
                    name: 'Progress',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    data: [
                        {
                            value: (props.total - props.completed),
                            name: 'Left'
                        },
                        {
                            value: props.completed,
                            name: 'Completed'
                        }
                    ],
                    roseType: 'radius',
                    label: {
                        color: '##5a06a1'
                    },
                    labelLine: {
                        lineStyle: {
                            color: '##5a06a1'
                        },
                        smooth: 0.2,
                        length: 10,
                        length2: 10
                    },
                    itemStyle: {
                        color: props.color,
                        shadowBlur: 200,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: function (idx) {
                        return Math.random() * 200;
                    }
                }
            ]
        }

        setOption(chartOptions)
    }, [props.title, props.completed, props.total])

    return <ReactECharts option={option} />;
};

export default Chart;